import {
  BetStatus,
  BetType,
  EntryRacer,
  SingleRaceRefund,
} from '../apollo/types/gen/graphql';

export const getHitSetNum = (srr: SingleRaceRefund): number => {
  let str = '';
  if (srr.hitNum1) {
    str += String(srr.hitNum1);
    if (srr.hitNum2) {
      str += String(srr.hitNum2);
      if (srr.hitNum3) {
        str += String(srr.hitNum3);
      }
    }
  }
  return Number(str);
};

/**
 * 着順データが同期されていないが払戻データが同期されている場合、三連単の結果から着順を取得し更新する
 */
export const setArrivalOrderFromRefund = (
  entryRacers: EntryRacer[],
  srrs: SingleRaceRefund[],
): EntryRacer[] => {
  const trifectaRefunds = srrs.filter(
    srr =>
      srr.betType === BetType.Trifecta && srr.betStatus === BetStatus.Decision,
  );
  // MEMO: 同着パターンは複雑なので一旦考慮しない
  if (trifectaRefunds.length === 1) {
    return entryRacers.map(racer => {
      if (racer.arrivalOrder === 0) {
        let arrivalOrder = 0;
        [
          trifectaRefunds[0].hitNum1,
          trifectaRefunds[0].hitNum2,
          trifectaRefunds[0].hitNum3,
        ].forEach((hitNum, i) => {
          if (racer.bicycleNum === hitNum) {
            arrivalOrder = i + 1;
          }
        });
        return {
          ...racer,
          arrivalOrder,
        };
      }
      return racer;
    });
  }
  return entryRacers;
};
